import { useTranslation } from 'react-i18next';
import { useBscTransactions } from '../hooks/useBscTransactions';

const TYPE_META = {
  DEPOSIT:  { icon: 'fa-arrow-down',   className: 'la-row--deposit'  },
  CLAIM:    { icon: 'fa-coins',        className: 'la-row--claim'    },
  REINVEST: { icon: 'fa-rotate',       className: 'la-row--reinvest' },
  REFERRAL: { icon: 'fa-user-plus',    className: 'la-row--referral' },
};

const relativeTime = (ts) => {
  const s = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  return `${Math.floor(s / 3600)}h ago`;
};

const formatUSDT = (n) => n.toLocaleString('en-US');

const SwapFeed = () => {
  const { t } = useTranslation();
  const { transactions, loading } = useBscTransactions(30000);

  return (
    <section id="live-activity" className="section-x live-activity">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('liveActivity.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('liveActivity.titleLead')}{' '}
              <span className="gold-text">{t('liveActivity.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('liveActivity.subtitle')}
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="la-panel" data-aos="fade-up">
              <div className="la-panel__header">
                <div className="la-panel__title">
                  <span className="la-pulse" />
                  <span>{t('liveActivity.panelTitle')}</span>
                </div>
                <div className="la-panel__legend">
                  <span className="sf-badge sf-badge--outline">{t('liveActivity.types.deposit')}</span>
                  <span className="sf-badge sf-badge--outline">{t('liveActivity.types.claim')}</span>
                  <span className="sf-badge sf-badge--outline">{t('liveActivity.types.reinvest')}</span>
                  <span className="sf-badge sf-badge--outline">{t('liveActivity.types.referral')}</span>
                </div>
              </div>

              <div className="la-list">
                {loading ? (
                  <div className="la-loading">
                    <i className="fas fa-circle-notch fa-spin" />
                    <span>{t('liveActivity.loading')}</span>
                  </div>
                ) : (
                  transactions.map((ev) => {
                    const meta = TYPE_META[ev.type];
                    return (
                      <div key={ev.id} className={`la-row ${meta.className}`}>
                        <div className="la-row__icon">
                          <i className={`fas ${meta.icon}`} />
                        </div>
                        <div className="la-row__type mono">
                          {t(`liveActivity.types.${ev.type.toLowerCase()}`)}
                          {ev.plan ? <span className="la-row__sub"> · {ev.plan}d</span> : null}
                          {ev.gen ? <span className="la-row__sub"> · Gen {ev.gen}</span> : null}
                        </div>
                        <a
                          className="la-row__wallet mono"
                          href={`https://bscscan.com/address/${ev.wallet}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {ev.walletShort}
                        </a>
                        <div className="la-row__amount mono tabular-nums">
                          <span className="la-row__sign">+</span>
                          {formatUSDT(ev.amount)}
                          <span className="la-row__asset">USDT</span>
                        </div>
                        <div className="la-row__time mono">{relativeTime(ev.timestamp)}</div>
                      </div>
                    );
                  })
                )}
              </div>

              <div className="la-panel__footer mono">
                <i className="fas fa-circle-info" />
                <span>{t('liveActivity.footer')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SwapFeed;
